import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { of } from "rxjs";
import { MedicalOrderOperation } from "src/app/model/medical-order-operation";
import { AdmissionService } from "src/app/services/admission.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { MenuService } from "src/app/services/menu.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";

@Component({
  selector: "app-integrated-admission-operation",
  templateUrl: "./integrated-admission-operation.component.html",
  styleUrls: ["./integrated-admission-operation.component.css"],
})
export class IntegratedAdmissionOperationComponent implements OnInit {
  form: FormGroup;
  returnurl: string;
  atention: string;
  loading: boolean;
  laoded: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private notificationToastService: NotificationToastService,
    private admissionService: AdmissionService,
    private integratedAdmissionService: IntegratedAdmissionService,
    private menuService: MenuService
  ) {
    this.menuService.setMenuTitle("Admisión", "operaciones");
    this.form = this.formBuilder.group({
      MedicalOrderOperation: [null],
    });
  }

  async finish() {
    try {
      this.loading = true;

      await this.admissionService.setAdmissionFinishedByAtention(this.atention);

      this.router.navigate([this.returnurl]);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loading = false;
    }
  }

  async setMedicalOrderOperation(atention: string) {

    try {
      const ids = await this.integratedAdmissionService.getMedicalAppointmentIdsByAtention(
        atention
      );

      const medicalOrderOperation = new MedicalOrderOperation();
      medicalOrderOperation.MedicalApponitmentIds = ids;
      medicalOrderOperation.MedicalApponitmentId = ids[0];

      this.form.patchValue({
        MedicalOrderOperation: medicalOrderOperation
      });

    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.laoded = true;
    }

  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      this.atention = params["Atention"];
      this.returnurl = params["return"];
      await this.setMedicalOrderOperation(this.atention);
    });
  }
}
